import styled from 'styled-components'

export const StyledRiskScoreWrapper = styled.div`
  .risk-score-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;
    &__create-invoice {
      display: inline-grid;
      justify-content:  end;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: max-content 175px;
      &__create-invoice {
        justify-content: start;
      }
    }
    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }
  
  .risk-score-table {
    &__head, &__row {
      grid-template-columns: minmax(150px, 250px) 100px 350px minmax(350px, 700px) repeat(4, 110px);
    }
    &__action {
      padding: 0 25px;
    }
    .MuiAccordion-root {
      margin: 0 !important;
      color: inherit;
      position: static;
      box-shadow: none;
      .accordion-title {
        padding: 0;
        display: block;
        .MuiAccordionSummary-content {
          margin: 0 !important;
          display: block;
        }
      }
      .accordion-content {
        display: grid;
        grid-template-columns: repeat(5, minmax(298px, 380px));
        background-color: #F5F4FA;
        &__item {
          padding: 15px 20px;
          border: 1px solid rgba(229, 229, 229, 0.5);
          span {
            padding-right: 5px;
            text-transform: capitalize;
          }
          b {
            color: #162954;
          }
        }
        &_description, &__alert {
          grid-column-start: 1;
          grid-column-end: 6;
        }
      }
    }
  }

  .icon-light-copy {
    padding-left: 5px;
    cursor: pointer;
  }
`;

export const StyledRiskScoreInvoiceWrapper = styled.div`
  display: inline-grid;
  grid-template-rows: 55px;
  button {
    height: 100%;
  }
`;